// ===============================================
// 🎮 STEAM SERVICE (ЧЕРЕЗ БЭКЕНД API)
// ===============================================

import backendApiService from './backend-api.service';

const steamService = {
  // ===============================================
  // 💱 КУРСЫ ВАЛЮТ
  // ===============================================

  // Получение курсов валют через бэкенд
  async getCurrencyRates() {
    try {
      console.log('💱 Запрос курсов валют через бэкенд...');
      
      const result = await backendApiService.getCurrencyRates();
      
      if (result.success && result.rates) {
        console.log('✅ Курсы валют получены через бэкенд:', result.source);
        
        // Сохраняем курсы в localStorage с временной меткой
        if (typeof window !== 'undefined' && window.localStorage) {
          const ratesData = {
            rates: result.rates,
            timestamp: Date.now(),
            source: result.source
          };
          localStorage.setItem('steam_currency_rates', JSON.stringify(ratesData));
        }
        
        return result.rates;
      } else {
        throw new Error('Неверный ответ от бэкенда');
      }
      
    } catch (error) {
      console.error('❌ Ошибка получения курсов валют:', error);
      
      // Пробуем использовать кеш
      const cachedRates = this.getCachedRates();
      if (cachedRates) {
        console.log('📦 Используем кешированные курсы валют');
        return cachedRates;
      }
      
      throw error;
    }
  },

  // Получение кешированных курсов
  getCachedRates() {
    if (typeof window === 'undefined' || !window.localStorage) {
      return null;
    }

    try {
      const cached = localStorage.getItem('steam_currency_rates');
      if (!cached) return null;

      const data = JSON.parse(cached);
      const now = Date.now();
      const maxAge = 2 * 60 * 60 * 1000; // 2 часа

      if (now - data.timestamp < maxAge) {
        return data.rates;
      } else {
        localStorage.removeItem('steam_currency_rates');
        return null;
      }
    } catch (error) {
      console.error('❌ Ошибка чтения кеша курсов:', error);
      return null;
    }
  },

  // Получение курсов с кешированием
  async getCurrencyRatesWithCache(forceRefresh = false) {
    try {
      // Если принудительное обновление, загружаем с сервера
      if (forceRefresh) {
        console.log('🔄 Принудительное обновление курсов валют...');
        return await this.getCurrencyRates();
      }

      // Сначала пробуем получить из кеша
      const cachedRates = this.getCachedRates();
      if (cachedRates) {
        console.log('📦 Используем кешированные курсы валют');
        return cachedRates;
      }

      // Если кеша нет, загружаем с сервера
      console.log('🌐 Загружаем курсы валют с сервера...');
      return await this.getCurrencyRates();
      
    } catch (error) {
      console.error('❌ Ошибка получения курсов валют:', error);
      
      // В случае ошибки возвращаем null - фронтенд должен обработать это
      console.log('❌ Не удалось получить курсы валют');
      return null;
    }
  },

  // Конвертация валют через бэкенд
  async convertCurrency(amount, fromCurrency, toCurrency) {
    try {
      console.log('🔄 Конвертация валют через бэкенд:', { amount, fromCurrency, toCurrency });
      
      const result = await backendApiService.convertCurrency(amount, fromCurrency, toCurrency);
      
      if (result.success) {
        console.log('✅ Конвертация выполнена:', result.converted);
        return result.converted.amount;
      } else {
        throw new Error('Ошибка конвертации валют');
      }
      
    } catch (error) {
      console.error('❌ Ошибка конвертации валют:', error);
      throw error;
    }
  },

  // ===============================================
  // 🎮 STEAM API
  // ===============================================

  // Проверка Steam аккаунта через бэкенд
  async verifySteamAccount(account) {
    try {
      console.log('🔍 Проверка Steam аккаунта через бэкенд:', account);
      
      const result = await backendApiService.verifySteamAccount(account);
      
      console.log('✅ Результат проверки Steam аккаунта:', result);
      return result;
      
    } catch (error) {
      console.error('❌ Ошибка проверки Steam аккаунта:', error);
      throw error;
    }
  },

  // Создание платежа Steam через бэкенд
  async createSteamPayment(account, amount, currency = 'USD') {
    try {
      console.log('💰 Создание платежа Steam через бэкенд:', { account, amount, currency });
      
      const result = await backendApiService.createSteamPayment(account, amount, currency);
      
      console.log('✅ Платеж Steam создан:', result);
      return result;
      
    } catch (error) {
      console.error('❌ Ошибка создания платежа Steam:', error);
      throw error;
    }
  },

  // Пополнение Steam аккаунта через бэкенд
  async topupSteamAccount(account, amount, paymentId) {
    try {
      console.log('🎮 Пополнение Steam аккаунта через бэкенд:', { account, amount, paymentId });
      
      const result = await backendApiService.topupSteamAccount(account, amount, paymentId);
      
      console.log('✅ Steam аккаунт пополнен:', result);
      return result;
      
    } catch (error) {
      console.error('❌ Ошибка пополнения Steam:', error);
      throw error;
    }
  },

  // ===============================================
  // 💳 СБП API
  // ===============================================

  // Создание QR-кода СБП через бэкенд
  async createSBPQR(amount, orderId, description = 'Пополнение Steam') {
    try {
      console.log('🔗 Создание QR-кода СБП через бэкенд:', { amount, orderId, description });
      
      const result = await backendApiService.createSBPQR(amount, orderId, description);
      
      console.log('✅ QR-код СБП создан:', result);
      return result;
      
    } catch (error) {
      console.error('❌ Ошибка создания QR-кода СБП:', error);
      throw error;
    }
  },

  // Проверка статуса платежа СБП через бэкенд
  async checkSBPPaymentStatus(paymentGuid) {
    try {
      console.log('🔍 Проверка статуса платежа СБП через бэкенд:', paymentGuid);
      
      const result = await backendApiService.checkSBPPaymentStatus(paymentGuid);
      
      console.log('✅ Статус платежа СБП:', result);
      return result;
      
    } catch (error) {
      console.error('❌ Ошибка проверки статуса СБП:', error);
      throw error;
    }
  },


  // ===============================================
  // 🔗 WEBHOOK
  // ===============================================

  // Проверка статуса webhook через бэкенд
  async checkWebhookStatus() {
    try {
      console.log('🔗 Проверка статуса webhook через бэкенд');
      
      const result = await backendApiService.checkWebhookStatus();
      
      console.log('✅ Статус webhook:', result);
      return result;
      
    } catch (error) {
      console.error('❌ Ошибка проверки webhook:', error);
      throw error;
    }
  },

  // ===============================================
  // 🏥 HEALTH CHECK
  // ===============================================

  // Проверка здоровья бэкенда
  async healthCheck() {
    try {
      console.log('🏥 Проверка здоровья бэкенда');
      
      const result = await backendApiService.healthCheck();
      
      console.log('✅ Статус бэкенда:', result);
      return result;
      
    } catch (error) {
      console.error('❌ Ошибка проверки здоровья бэкенда:', error);
      throw error;
    }
  },

  // ===============================================
  // 🛠️ УТИЛИТЫ
  // ===============================================

  // Генерация уникального ID заказа
  generateOrderId() {
    return `order_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  },

  // Генерация уникального ID платежа
  generatePaymentId() {
    return `payment_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  },

  // Форматирование суммы валюты
  formatCurrency(amount, currency = 'USD') {
    const formatter = new Intl.NumberFormat('ru-RU', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2
    });
    return formatter.format(amount);
  },

  // Проверка доступности бэкенда
  async isBackendAvailable() {
    try {
      await this.healthCheck();
      return true;
    } catch (error) {
      console.warn('⚠️ Бэкенд недоступен:', error.message);
      return false;
    }
  }
};

export default steamService;
